import { render, staticRenderFns } from "./CollapseRowV2.vue?vue&type=template&id=a6f7aa44&scoped=true&"
import script from "./CollapseRowV2.vue?vue&type=script&lang=ts&"
export * from "./CollapseRowV2.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseRowV2.vue?vue&type=style&index=0&id=a6f7aa44&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f7aa44",
  null
  
)

export default component.exports